module.exports = __webpack_public_path__ + "img/logo.71e83007.png";